import React, { useState, useEffect } from "react";
import {
  Box,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Switch,
  HStack,
  Text,
} from "@chakra-ui/react";
import Prism from "prismjs";
import "prismjs/components/prism-json"; // enable JSON syntax highlighting
import "prismjs/themes/prism-tomorrow.css"; // pick a theme (you can change)

const RenderPropertiesWithToggle = ({ title, propsObj }) => {
  const [jsonMode, setJsonMode] = useState(false);

  useEffect(() => {
    if (jsonMode) {
      Prism.highlightAll();
    }
  }, [jsonMode, propsObj]);

  if (!propsObj || Object.keys(propsObj).length === 0) {
    return <Box>No properties</Box>;
  }

  return (
    <Box>
      {/* Switch Toggle */}
      <HStack justify="space-between" mb={2}>
        <Text fontWeight="semibold">{title}</Text>
        <HStack>
          
          <Switch
            size="sm"
            isChecked={jsonMode}
            onChange={() => setJsonMode(!jsonMode)}
            colorScheme="blue"
          />
          <Text fontSize="sm">JSON</Text>
        </HStack>
      </HStack>

      {/* Render Table or JSON */}
      {jsonMode ? (
        <Box
          as="pre"
          p={3}
          borderRadius="md"
          bg="gray.900"
          fontSize="sm"
          overflowX="auto"
        >
          <code className="language-json">
            {JSON.stringify(propsObj, null, 2)}
          </code>
        </Box>
      ) : (
        <Table size="sm" variant="unstyled">
          <Thead>
            <Tr>
              <Th>Key</Th>
              <Th>Value</Th>
            </Tr>
          </Thead>
          <Tbody>
            {Object.entries(propsObj).map(([key, value]) => (
              <Tr key={key}>
                <Td>{key}</Td>
                <Td>{String(value)}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      )}
    </Box>
  );
};

export default RenderPropertiesWithToggle;
